<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col :cols="isForm ? 3 : 12">
                <rkm-form-select
                    :options="form.tipos"
                    :validations="validations.tipoId"
                    label="Tipo"
                    text-field="descricao"
                    v-model="model.tipoId"
                    value-field="id"
                    show-default-option
                />
            </rkm-col>

            <rkm-col :cols="isForm ? 9 : 12">
                <rkm-form-input
                    :validations="validations.agenteSubstanciaEspecifica"
                    label="Agente / substância específica"
                    v-model="model.agenteSubstanciaEspecifica"
                    uppercase
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    mixins: [ repository, stringCase, object, error ],
    props: {
        id: { type: Number },
        layout: { type: String, default: 'form' }
    },
    data: () => ({
        repositories: {
            alergia: null,
        },
        form: {
            tipos: [],
        },
        model: {
            tipoId: null,
            agenteSubstanciaEspecifica: null
        },
    }),
    computed: {
        validations() {

            return {
                tipoId: { required: true },
                agenteSubstanciaEspecifica: { required: true, min: 3, max: 100 },
            }
        },
        isForm() {

            return this.layout === 'form'
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        validate() {

            return this.$refs.Form.validate()
        },
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.alergia.edit(this.id)
                : this.repositories.alergia.create()

            request
                .then(({ data }) => {

                    Object.assign(this.form, data.form)
                    Object.assign(this.model, data.model || {})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.alergia.update(this.id, this.prepareData())
                        : this.repositories.alergia.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            data.tipo = this.form.tipos.find(t => t.id == data.tipoId)

                            delete data.tipoId

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
    },
    created() {

        this.repositories.alergia = this.getConectaSusRepository('cadastro.sujeitoAtencao.alergia')

        this.load()
    },
}
</script>